module.exports = __webpack_public_path__ + "img/bg_1440_0_1012.2ab79da0.png";